import React, { useEffect } from "react";
import PanelStandaloneManager, { PanelStandaloneMessage } from "./PanelStandaloneManager";
import { StandaloneModal } from "../../components/layout/StandaloneModal";

export const PanelStandaloneContainer: React.FunctionComponent = () => {
  const [state, setState] = React.useState<PanelStandaloneMessage[]>([]);

  useEffect(() => {
    PanelStandaloneManager.addChangeListener(handleStoreChange);
    return () => {
      PanelStandaloneManager.removeChangeListener(handleStoreChange);
    };
  }, []);

  function handleStoreChange(panelStandalones: PanelStandaloneMessage[]) {
    setState(panelStandalones);
  }

  if (!state?.length) return null;
  const item = state[0];
  return (
    <StandaloneModal
      {...item}
      onHide={() => {
        setState((s) => s.slice(1));
      }}
    />
  );
};
